const validateCheckAvailabiltyRequest = (segment) => {
  const required = ['origin', 'destination', 'departureDate', 'carrierCode', 'flightNumber'];
  if (!segment) {
    return {
      isValid: false,
      message:
        'Origin, Destination, Departure Date, airline and Flight Number are required to request air availability.',
    };
  }

  const missing = required.filter((field) => !segment[field]);

  if (missing.length > 0) {
    const formatted = missing.map((f) => f.charAt(0).toUpperCase() + f.slice(1)).join(', ');
    return {
      isValid: false,
      message: `${formatted} ${missing.length === 1 ? 'is' : 'are'} required to request air availability.`,
    };
  }

  return { isValid: true, message: '' };
};

export default validateCheckAvailabiltyRequest;
